// extracted by mini-css-extract-plugin
export var arrowLink = "PageDataBodyInteriorPromo-module--arrowLink--G9S7+";
export var heading = "PageDataBodyInteriorPromo-module--heading--VT8Gn";
export var image = "PageDataBodyInteriorPromo-module--image--EA9kt";
export var promo = "PageDataBodyInteriorPromo-module--promo--tZ2gS";
export var promoCopy = "PageDataBodyInteriorPromo-module--promoCopy--G1SDs";
export var subheading = "PageDataBodyInteriorPromo-module--subheading--fQNrx";